import { show_main_mobile_menu } from "../MobileMenu";
import CONSTANTS from "../../Constants/Constants";
import { useState } from "react";

import WillgoLogo from '../../WillgoLogo.png';
import LOGO_PLACEHOLDER from "../../LOGO_PLACEHOLDER.jpg";

import {
    show_login_page,
    show_home_page,
    show_trips_page,
    show_explore_page,
    show_full_search_form
} from '../../helpers/PageRoutingFuncs';


const Type1Header = (props) => {

    const [showMobileMenu, setShowMobileMenu] = useState(false);

    const {
        hasNewMessageFromParent,
        currentParentMessge,
        IS_DEBUG,
        bookingEngine,
        agentDetails,
        _company_name,
        _logo_url,
        PRODUCT_TYPES,
        isFlightPT,
        isStaysPT,
        isRentalCarsPT,
    } = props;

    let logo_size = 35; // defaults 35 => default;
    let margin_top = 0;
    if(bookingEngine?.logoSize){
        if(bookingEngine.logoSize.trim().toLowerCase()==="medium"){
            logo_size = 50;
            margin_top = 0;
        }else if(bookingEngine.logoSize.trim().toLowerCase()==="large"){
            logo_size = 70;
            margin_top = 0;
        }
    }

    return (
        <>
            {
                (hasNewMessageFromParent && currentParentMessge?.from_welldugo_oc && IS_DEBUG) &&
                <div style={{backgroundColor: "crimson", position: "fixed", top: 0, left: 0, width: "100vw", zIndex: 3000, padding: 20}}>
                    <div className="wrapper">
                        <p style={{color: "white", fontSize: 13}}>
                            <i style={{marginRight: 10, color: "lightgreen"}}
                                className="fa-solid fa-info-circle"></i>
                            Operational Center Action Recieved: {
                                JSON.stringify(currentParentMessge?.postBody)
                            }
                        </p>
                    </div>
                </div>
            }
            <header id="site_main_header" style={{backgroundColor: bookingEngine?.headerBg}}>
                <div className="wrapper">
                    <div className="header_content_container" style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                        {
                            bookingEngine?.showHeaderCompany ?
                            <div style={{height: "75px", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center"}}>
                                <div onClick={()=>{

                                    // Ask before leaving checkout page
                                    if(CONSTANTS.checkout_pages.app_level_checkout_status===true) {
                                    let userResponse = window.confirm("Do you want to exit the checkout page?");
                                    if (userResponse) {
                                        //console.log("User clicked OK");
                                        // Reset app level checkout status
                                        CONSTANTS.checkout_pages.app_level_checkout_status=false;
                                    } else {
                                        //console.log("User clicked Cancel");
                                        return;
                                    }
                                    }

                                    window.location.href=`${agentDetails?.website_url}`

                                }} style={{marginLeft: -5}} className="site-logo">
                                    {
                                        !bookingEngine?.hideCompanyLogo &&
                                        <p className="site-logo-img">
                                            <img style={{minWidth: logo_size, height: logo_size, marginTop: margin_top,
                                                borderRadius: `${bookingEngine?.headerLogoBorderRadius}%`}} 
                                                src={(_logo_url || LOGO_PLACEHOLDER)}/>
                                            {/*<i style={{color: "pink", marginRight: 10}} className="fa-solid fa-user" ></i>*/}
                                        </p>
                                    }
                                    {
                                        !bookingEngine?.hideCompanyName &&
                                        <div className="site-logo-txt">
                                            <p style={{color: bookingEngine?.headerCompanyTxtColor, fontSize: 16}}>
                                                {
                                                    _company_name ||
                                                    "Business Name"
                                                }</p>
                                        </div>
                                    }
                                </div>
                            </div> : <div style={{height: "75px"}}></div>
                        }
                        <div style={{display: "flex", alignItems: "center"}}>
                            {
                                bookingEngine?.showHeaderMenu &&
                                <div className="header-menu" style={{display: "flex", alignItems: "center"}}>
                                    <p className="hide_at_500" onClick={()=>{
                                        window.__change_proct_type("none");
                                        window.location.href="/"
                                    }}
                                    style={{color: false ? bookingEngine?.headerMenuActiveTxtColor : bookingEngine?.headerMenuTxtColor, marginRight: 20, fontSize: 13, fontWeight: 'bolder', textDecoration: "underline", cursor: "pointer"}}>
                                    <i style={{marginRight: 10, color: false ? bookingEngine?.headerMenuActiveIconColor : bookingEngine?.headerMenuIconColor}}
                                        className="fa-solid fa-tools"></i>
                                    <span className="hide_at_500" style={{fontSize: "inherit", fontFamily: "'Prompt', Sans-serif"}}>
                                        Tools</span>
                                </p>
                                <p onClick={()=>{
                                        window.__change_proct_type(PRODUCT_TYPES?.flights);
                                        window.location.href="/search?product=0"
                                    }}
                                    style={{color: isFlightPT ? bookingEngine?.headerMenuActiveTxtColor : bookingEngine?.headerMenuTxtColor, marginRight: 20, fontSize: 13, fontWeight: 'bolder', textDecoration: "underline", cursor: "pointer"}}>
                                    <i style={{marginRight: 10, color: isFlightPT ? bookingEngine?.headerMenuActiveIconColor : bookingEngine?.headerMenuIconColor}}
                                        className="fa-solid fa-plane-departure"></i>
                                    <span className="hide_at_500" style={{fontSize: "inherit", fontFamily: "'Prompt', Sans-serif"}}>
                                        Flight</span>
                                </p>
                                <p onClick={()=>{
                                        window.__change_proct_type(PRODUCT_TYPES?.stays);
                                        window.location.href="/search?product=1"
                                    }} 
                                    style={{color: isStaysPT ? bookingEngine?.headerMenuActiveTxtColor : bookingEngine?.headerMenuTxtColor, marginRight: 20, fontSize: 13, fontWeight: 'bolder', textDecoration: "underline", cursor: "not-allowed"}}>
                                    <i style={{marginRight: 10, color: isStaysPT ? bookingEngine?.headerMenuActiveIconColor : bookingEngine?.headerMenuIconColor}}
                                        className="fa-solid fa-hotel"></i>
                                    <span className="hide_at_500" style={{fontSize: "inherit", fontFamily: "'Prompt', Sans-serif"}}>
                                        Stays</span>
                                </p>
                                <p onClick={()=>{
                                        window.__change_proct_type(PRODUCT_TYPES?.rental_cars);
                                        window.location.href="/search?product=2"
                                    }}
                                    style={{color: isRentalCarsPT ? bookingEngine?.headerMenuActiveTxtColor : bookingEngine?.headerMenuTxtColor, fontSize: 13, fontWeight: 'bolder', textDecoration: "underline", cursor: "not-allowed"}}>
                                    <i style={{color: isRentalCarsPT ? bookingEngine?.headerMenuActiveIconColor : bookingEngine?.headerMenuIconColor}}
                                        className="fa-solid fa-car"></i>
                                    <span className="hide_at_500" style={{marginLeft: 10, marginRight: 20, fontSize: "inherit", fontFamily: "'Prompt', Sans-serif"}}>
                                        Cars</span>
                                </p>
                                <p className="hide_at_500" onClick={()=>{
                                        window.__change_proct_type("none");
                                        window.location.href="/deals"
                                    }}
                                    style={{color: false ? bookingEngine?.headerMenuActiveTxtColor : bookingEngine?.headerMenuTxtColor, marginRight: 20, fontSize: 13, fontWeight: 'bolder', textDecoration: "underline", cursor: "not-allowed"}}>
                                    <i style={{marginRight: 10, color: false ? bookingEngine?.headerMenuActiveIconColor : bookingEngine?.headerMenuIconColor}}
                                        className="fa-solid fa-box-open"></i>
                                    <span style={{fontSize: "inherit", fontFamily: "'Prompt', Sans-serif"}}>
                                        Packages</span>
                                </p>
                                <p className="hide_at_500" onClick={()=>{
                                        window.__change_proct_type("none");
                                        window.location.href="/deals?view_itin=true&public=true"
                                    }}
                                    style={{color: false ? bookingEngine?.headerMenuActiveTxtColor : bookingEngine?.headerMenuTxtColor, fontSize: 13, fontWeight: 'bolder', textDecoration: "underline", cursor: "not-allowed", marginRight: 15}}>
                                    <i style={{marginRight: 10, color: false ? bookingEngine?.headerMenuActiveIconColor : bookingEngine?.headerMenuIconColor}}
                                        className="fa-solid fa-route"></i>
                                    <span className="hide_at_500" style={{fontSize: "inherit", fontFamily: "'Prompt', Sans-serif"}}>
                                        Itineraries</span>
                                </p>
                                </div>
                            }
                            <div onClick={()=>{
                                    window.location.href="/account"
                                }}
                                style={{cursor: "pointer", marginLeft: 20, marginRight: 10, width: 30, height: 30, borderRadius: "100%", display: "flex", justifyContent: "center", alignItems: "center"/*, backgroundColor: bookingEngine?.headerMenuIconColor*/}}>
                                    <i style={{color: bookingEngine?.headerMenuIconColor /*bookingEngine?.headerMenuTxtColor*/, fontSize: 32}}
                                        className="fa-solid fa-circle-user"></i>
                            </div>
                            <button onClick={()=>setShowMobileMenu(!showMobileMenu)} style={{marginRight: 10, background: bookingEngine?.actionButtonsBg, border: "none", borderRadius: "100%", width: 35, height: 35, boxShadow: "1px 2px 3px rgba(0,0,0,0.33)"}} 
                                className="hidden justify-center items-center flex_at_500 transition-all rounded-full">{/**hover:text-indigo-600 hover:bg-slate-50*/}
                                <i style={{color: bookingEngine?.actionButtonsIconColor, fontSize: 17}}
                                className={("fa-solid "+(showMobileMenu ? "fa-angle-up" : "fa-angle-down"))}></i>
                            </button>
                            {
                                showMobileMenu &&
                                <nav style={{backgroundColor: "white", minWidth: 200, boxShadow: "1px 2px 3px rgba(0,0,0,0.33)", padding: 20, position: "absolute", top: "100%", right: 0, borderRadius: 8}} className="items-center gap-8">
                                    <ul>
                                        <li style={{padding: 10}}>
                                        <a onClick={()=>{
                                                window.__change_proct_type("tools");
                                                window.location.href="/"
                                            }} className="text-sm font-bold text-indigo-600 relative py-5" style={{color: false ? bookingEngine?.headerMenuActiveTxtColor : bookingEngine?.headerMenuTxtColor, cursor: "pointer"}}>
                                            <i style={{marginRight: 20, color: false ? bookingEngine?.headerMenuActiveIconColor : bookingEngine?.headerMenuIconColor}}
                                            className="fa-solid fa-tools"></i>
                                            Tools
                                        </a>
                                        </li>
                                        <li style={{padding: 10}}>
                                        <a onClick={()=>{
                                                window.__change_proct_type(PRODUCT_TYPES?.flights);
                                                window.location.href="/search?product=0"
                                            }} className="text-sm font-bold text-indigo-600 relative py-5" style={{color: isFlightPT ? bookingEngine?.headerMenuActiveTxtColor : bookingEngine?.headerMenuTxtColor, cursor: "pointer"}}>
                                            <i style={{marginRight: 20, color: isFlightPT ? bookingEngine?.headerMenuActiveIconColor : bookingEngine?.headerMenuIconColor}}
                                            className="fa-solid fa-plane-departure"></i>
                                            Flights
                                        </a>
                                        </li>
                                        <li style={{padding: 10}}>
                                        <a onClick={()=>{
                                            window.__change_proct_type(PRODUCT_TYPES?.stays);
                                            window.location.href="/search?product=1"
                                            }} className="text-sm font-bold text-indigo-600 relative py-5 hover:text-indigo-600" style={{color: isStaysPT ? bookingEngine?.headerMenuActiveTxtColor : bookingEngine?.headerMenuTxtColor, cursor: "pointer"}}>
                                            <i style={{marginRight: 20, color: isStaysPT ? bookingEngine?.headerMenuActiveIconColor : bookingEngine?.headerMenuIconColor}}
                                            className="fa-solid fa-hotel"></i>
                                            Hotels
                                        </a>
                                        </li>
                                        <li style={{padding: 10}}>
                                        <a onClick={()=>{
                                                window.__change_proct_type(PRODUCT_TYPES?.rental_cars);
                                                window.location.href="/search?product=2"
                                            }} className="text-sm font-bold text-indigo-600 relative py-5 hover:text-indigo-600" style={{color: isRentalCarsPT ? bookingEngine?.headerMenuActiveTxtColor : bookingEngine?.headerMenuTxtColor, cursor: "pointer"}}>
                                            <i style={{marginRight: 20, color: isRentalCarsPT ? bookingEngine?.headerMenuActiveIconColor : bookingEngine?.headerMenuIconColor}}
                                                className="fa-solid fa-car"></i>
                                            Rental Car
                                        </a>
                                        </li>
                                        <li style={{padding: 10}}>
                                        <a onClick={()=>{
                                            window.__change_proct_type("none");
                                                window.location.href="/deals"
                                            }} className="text-sm font-bold text-indigo-600 relative py-5 hover:text-indigo-600" style={{color: bookingEngine?.headerMenuTxtColor, cursor: "pointer"}}>
                                            <i style={{marginRight: 20, color: bookingEngine?.headerMenuIconColor}}
                                            className="fa-solid fa-box-open"></i>
                                            Packages
                                        </a>
                                        </li>
                                        <li style={{padding: 10}}>
                                        <a onClick={()=>{
                                            window.__change_proct_type("none");
                                                window.location.href="/deals?view_itin=true&public=true"
                                            }} className="text-sm font-bold text-indigo-600 relative py-5 hover:text-indigo-600" style={{color: bookingEngine?.headerMenuTxtColor, cursor: "pointer"}}>
                                            <i style={{marginRight: 20, color: bookingEngine?.headerMenuIconColor}}
                                            className="fa-solid fa-route"></i>
                                            Itineraries
                                        </a>
                                        </li>
                                        <li style={{padding: 10}}>
                                        <a onClick={()=>{
                                            window.__change_proct_type("none");
                                                window.location.href="/deals?view_itin=true"
                                            }} className="text-sm font-bold text-indigo-600 relative py-5 hover:text-indigo-600" style={{color: bookingEngine?.headerMenuTxtColor, cursor: "pointer"}}>
                                            <i style={{marginRight: 20, color: bookingEngine?.headerMenuIconColor}}
                                            className="fa-solid fa-list-check"></i>
                                            Your Itineraries
                                        </a>
                                        </li>
                                    </ul>
                                </nav>
                            }
                        </div>
                    </div>
                </div>
            </header>
        </>
    );

}

export default Type1Header;